import React, { useEffect, useState } from 'react';
import api, {BACKEND_URL} from '../api/api';
import ProfileImageUploader from '../components/ProfileImageUploader';

const Profile = () => {
  const [user, setUser] = useState(null);
  const [newName, setNewName] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // REGEX para validar nombres
  const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]{2,40}$/;

  useEffect(() => {
    api.get("/users/profile")
      .then(res => {
        setUser(res.data);
        setNewName(res.data.name); // inicializa el input
      })
      .catch(() => setUser(null));
  }, []);

  if (!user) return <h2>Cargando perfil...</h2>;

  // Guardar nuevo nombre
  const handleSaveName = async () => {
    setError("");
    setSuccess("");

    if (!nameRegex.test(newName)) {
      return setError(
        "El nombre debe tener entre 2 y 40 letras y solo puede contener letras, espacios, guiones y apóstrofes."
      );
    }

    try {
      const res = await api.put("/users/update", { name: newName });

      setUser({ ...user, name: newName });
      setSuccess("Nombre actualizado correctamente.");
    } catch (err) {
      setError("Error al actualizar el nombre.");
    }
  };

  return (
    <div>
      <h1>Perfil</h1>

      <p><b>Email:</b> {user.email}</p>
      <p><b>Rol:</b> {user.role}</p>

      {/* Editar nombre */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Editar nombre</h3>
        <input
          type="text"
          value={newName}
          onChange={e => setNewName(e.target.value)}
          style={{
            padding: "8px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            width: "250px"
          }}
        />
        <button
          onClick={handleSaveName}
          style={{
            marginLeft: "10px",
            padding: "8px 12px",
            background: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Guardar
        </button>

        {error && <p style={{ color: "red", marginTop: "6px" }}>{error}</p>}
        {success && <p style={{ color: "green", marginTop: "6px" }}>{success}</p>}
      </div>

      {/* Imagen */}
      <div>
        <h3>Imagen de perfil</h3>

        {user.profile_image && (
          <img
            src={`${BACKEND_URL}/uploads/${user.profile_image}`} 
            height={120}
            alt="avatar"
            style={{ borderRadius: "12px", objectFit: "cover" }}
          />
        )}

        <ProfileImageUploader
          onUploaded={(newImg) => {
            setUser({
              ...user,
              profile_image: newImg.replace("/uploads/", "")
            });
          }}
        />
      </div>
    </div>
  );
};

export default Profile;
